/**
 * P0-24: Hello Island —— P0 验收用占位岛。
 *
 * 每 tick 显示引擎 tick 计数（game.timer.ticksTotal，classes.game.Timer，game.js:26/69），
 * 验证：GameBridge 订阅链路、useGameTick 精确更新、Tailwind 语义色
 * 跟随旧主题 CSS 变量（切主题即变色）。
 *
 * 固定在视口右下角，挂载在 body 直挂 div 上——位于 DesktopUI.render()
 * 的 dojo.empty 影响半径之外（P0-27 验收点）。
 */
import { useGameTick } from "../bridge/useGameTick";

export default function HelloIsland() {
  const ticks = useGameTick((game) => game?.timer?.ticksTotal ?? null);

  return (
    <div className="fixed bottom-2 right-2 z-[9999] rounded border border-btn-border bg-surface px-3 py-1 text-xs text-text opacity-80">
      {ticks === null ? "new-ui: loading…" : `new-ui · ticks ${ticks}`}
    </div>
  );
}
